import { BackendError } from './base';
import General from './general';

class InvalidCoverageId extends BackendError {}
class GuaranteeQuoteDownloadNotAvailable extends BackendError {}
class InsuranceNotFound extends BackendError {}
class InvalidBeginDate extends BackendError {}
class TenantLandlordCpfConflict extends BackendError {}
class TransmissionFailedUnauthorizedCard extends BackendError {}
class TransmissionCannotBeRequested extends BackendError {}
class InsuranceDoesNotExist extends BackendError {}
class TransmissionFailed extends BackendError {}
class InsuranceQuoteDoesNotExist extends General.NotFound {}
class InsuranceProposalDoesNotExist extends General.NotFound {}
class InsurancePolicyDoesNotExist extends General.NotFound {}
class AddressAlreadyInsured extends BackendError {}

export default {
    InvalidCoverageId,
    GuaranteeQuoteDownloadNotAvailable,
    InsuranceNotFound,
    InvalidBeginDate,
    TenantLandlordCpfConflict,
    TransmissionFailedUnauthorizedCard,
    TransmissionCannotBeRequested,
    InsuranceDoesNotExist,
    TransmissionFailed,
    InsuranceQuoteDoesNotExist,
    InsurancePolicyDoesNotExist,
    InsuranceProposalDoesNotExist,
    AddressAlreadyInsured,
};
